import { RootState } from 'store/configureStore';

export const isProgramsAndResourcesLoading = (store: RootState) =>
  store.resources.isLoading;

export const resourcesSelector = (store: RootState) =>
  store.resources.resources;

export const cohortProgramsSelector = (store: RootState) =>
  store.resources.cohortPrograms;

// ************************ Partner Resources **************************//

export const partnerResourcesListSelector = (store: RootState) =>
  store.resources.partnerResources.partnerResourcesList;
export const partnerResourcesCountSelector = (store: RootState) =>
  store.resources.partnerResources.partnerResourcesCount;
export const partnerResourcesIsLoadingSelector = (store: RootState) =>
  store.resources.partnerResources.isLoading;

export const partnerResourcesFilterSettingsSelector = (state: RootState) =>
  state.resources.partnerResources.partnerResourcesFilterDetails;

export const partnerResourcesFilterEnabledSelector = (state: RootState) =>
  state.resources.partnerResources.partnerResourcesFilterDetails?.isEnabled;

export const isPartnerResourcesFilterDetailsLoadingSelector = (
  state: RootState,
) => state.resources.partnerResources.isPartnerResourcesFilterDetailsLoading;

export const partnerResourcesIsMutatingSelector = (store: RootState) =>
  store.resources.partnerResources.isMutatingResource;
